import { u as useLocalStorageSVG } from './useLocalStorageSVG-be835b86.js';
import 'react';

/*
Fetches SVG symbol from CDN and places inline on page
Source for SVG symbol is "icons.svg"
Which is uploaded to the stipple/assets directory

Fetching instead of placing inline to leverage browser caching
And to reduce bundle size, since icons are one of the largest assets
for this package

*/

function IconSymbol() {
  const version = 17;
  useLocalStorageSVG({
    url: "https://screentone.djnews.tools/assets/icons." + version + ".svg",
    id: 'st-icons',
    version
  });
  return null;
}

export default IconSymbol;
